import styled from "styled-components"
import { TKIconLogo } from "../assets/images/svgs";
import { TKIconBlueLogo } from "../assets/images/svgs";
import { NavLink } from "react-router-dom";

const CompanyLogo = ({ text, className, blue }) => {

  return (
    <NavLink to="/">
      {blue ? <TKIconBlueLogo /> : (
        <div className="flex flex-col hover:cursor-pointer">
          <TKIconLogo className={className} />
          <LogoSubText>
            {text}
          </LogoSubText>
        </div>
      )}
    </NavLink>
  )
}

export default CompanyLogo

const LogoSubText = styled.p`
  margin: 0;  
  color: #FFFFFF;
  font-style: italic;
  white-space: nowrap;
  font-size: 12px;
`;